import * as z from 'zod';

export const billingSystemQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type BillingSystemQueryLinkerSchema = z.infer<typeof billingSystemQueryLinkerSchema>;
